exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cta[data-v-ce23e148] {\n  font-family: \"Lato\";\n  font-weight: 300;\n  margin: 30px 0 20px;\n  text-align: center;\n}\n.logo[data-v-ce23e148] {\n  width: 135px;\n  margin: 0 auto 40px auto;\n  display: block;\n}\n.training-step-body .main-outfit-container[data-v-ce23e148] {\n  height: 75vh;\n}", ""]);

// exports
